const colors = {
  primary: '#ff4895',
  secondary: ' #F9F4F4',
  fontBase: '#373E49',
  placeholder: '#8C8C8C',
  error: '#f53354',
  success: '#50c24e',
  disabled: '#f3f3f3',
  bgInput: '#f9f4f4',
  bgInputHover: '#f7e5e9',
  borderInput: '#f7e5e9',

  black: '#000',
  gray700: '#373E49',
  gray600: '#8C8C8C',
  gray500: '#D1D1D1',
  gray400: '#DDDDDD',
  gray300: '#E8E8E8',
  gray200: '#F3F3F3',
  gray100: '#F9F4F4',
  white: '#fff',
};

const colorSets = {
  primary: {
    base: '#ff4895',
    font: '#fff',
    hover: 'brightness(1.2)',
    active: 'contrast(1.8)',
    disabled: 'opacity(0.4)',
  },
  secondary: {
    base: '#F9F4F4',
    font: '#373E49',
    hover: 'brightness(0.9)',
    active: 'invert(1)',
    disabled: 'invert(0.2) opacity(0.4)',
  },
};

const spacing = {
  xxs: '4px',
  xs: '8px',
  s: '16px',
  m: '24px',
  l: '32px',
  xl: '40px',
  xxl: '48px',
};

const surface = {
  borderRadius: '12px',
  boxShadow: 'rgb(0 0 0 / 10%) 0px 12px 40px -12px',
  boxShadowHover: '0px 20px 46px 0 rgba(0, 0, 0, .1)',
};

const fontStyles = {
  family: "'Noto Sans KR', sans-serif",
  lineHeight: 1.5,
};

const fontSizes = {
  xxs: '12px',
  xs: '14px',
  sm: '15px',
  base: '16px',
  md: '18px',
  lg: '24px',
  xl: '36px',
};

const iconSizes = {
  s: 16,
  sm: 20,
  m: 24,
  l: 32,
  xl: 40,
};

const buttonSizes = {
  sm: '36px',
  base: '52px',
};

const inputSizes = {
  sm: '48px',
  base: '52px',
  defaultWidth: 288,
};

const headerHeight = '80px';

const breakPoint = {
  mobile: '576px',
  tablet: '640px',
};

const mediaQuery = (breakpoint, minOrMax = 'max') => {
  return `@media (${minOrMax}-width: ${breakPoint[breakpoint]})`;
};

const theme = {
  colors,
  colorSets,
  spacing,
  surface,
  fontStyles,
  fontSizes,
  iconSizes,
  buttonSizes,
  inputSizes,
  headerHeight,
  breakPoint,
  mediaQuery,
};

export default theme;
